const pirateShopItems = [
  {
    title: "10 DealDuck$",
    miniimg: "donate-images/dducks01.webp",
    dealDucks: 10,
    cost: 50,
    type: "dealDucks",
    color: "rgb(70, 12, 146)",
  },
  {
    title: "50 DealDuck$",
    miniimg: "donate-images/dducks02.webp",
    dealDucks: 50,
    cost: 200,
    type: "dealDucks",
    color: "rgb(70, 12, 146)",
  },
  {
    title: "200 DealDuck$",
    miniimg: "donate-images/dducks03.webp",
    dealDucks: 200,
    cost: 700,
    type: "dealDucks",
    color: "rgb(70, 12, 146)",
  },
  {
    title: "500 DealDuck$",
    miniimg: "donate-images/dducks04.webp",
    dealDucks: 500,
    cost: 1500,
    type: "dealDucks",
    color: "rgb(70, 12, 146)",
  },
];
export default pirateShopItems;
